import { z } from "zod";

const durationCountSchema = z.int().min(0).max(1_000_000);

export const timeToDueDateFilterSchema = z.object({
    direction: z.enum(["overdue", "upcoming"]),
    unit: z.enum(["hours", "days"]),
    comparison: z.discriminatedUnion("type", [
        z.object({ type: z.literal("atLeast"), value: durationCountSchema }),
        z.object({ type: z.literal("atMost"), value: durationCountSchema }),
    ]),
});

export type TimeToDueDateFilter = z.infer<typeof timeToDueDateFilterSchema>;

const encodedTimeToDueDateFilterSchema = z
    .tuple([
        z.string(),
        z.string(),
        z.string(),
        z
            .string()
            .regex(/^\d+$/, "Expected a non-negative integer")
            .transform(Number),
    ])
    .transform(([direction, unit, type, value]) => ({
        direction,
        unit,
        comparison: { type, value },
    }))
    .pipe(timeToDueDateFilterSchema);

export const timeToDueDateFilterCodec = z.codec(
    z.string(),
    timeToDueDateFilterSchema.nullable(),
    {
        encode: (value) =>
            value === null
                ? "null"
                : [
                      value.direction,
                      value.unit,
                      value.comparison.type,
                      value.comparison.value,
                  ].join(","),
        decode: (value) => {
            const result = encodedTimeToDueDateFilterSchema.safeParse(
                value.split(",")
            );
            return result.success ? result.data : null;
        },
    }
);
